export default __webpack_public_path__ + "static/media/dnsleakimg2.328170c7.png";